/**
 * Created by chenzheyu on 2017/7/3.
 */
import Vue from 'vue'
import InitData from '../store/configure'
import WX from 'weixin-js-sdk'
import JSONBig from 'json-bigint-xk'
// callback(data.body)

export default {
  inform (obj, callback) { // 通知查询
    var params = {
      'app_key': InitData.appKey,
      'passengerId': obj.passengerId,
      'page': obj.page,
      'rows': obj.rows
    }
    Vue.http.get(InitData.weixinUrl + '/v5/passenger/getNotice', {params}).then((data) => {
      callback(data.body.data)
    })
  },
  postCustomerPreSave (params, callback) { // 获取用户余额
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/customerPreSave', params)
    Vue.http.get('/v1/customerPreSave', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  getCustomerPreSaveSerials (params, callback) { // 资金流水
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/customerPreSaveSerials', params)
    Vue.http.get('/v1/customerPreSaveSerials', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },

  /**
   * 添加优惠券
   * @param {*} params 
   * @param {*} callback 
   */
  addCoupon (params, callback) {
    params = Vue.prototype.$utils.objKeySort('/api/v1/giftCouponByRandId', params)
    let url = InitData.weixinUrl + '/giftCouponByRandId'
    Vue.http.post(url, params, {emulateJSON: true}).then(
      data => { callback(JSONBig.parse(data.bodyText)) }
    )
  },
  findNearDrivers (params, callback) { // v5查询附近司机
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/getNearDrivers', params)
    let url = InitData.serverUrl + '/getNearDrivers'
    Vue.http.get(url, {params}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  queryCoupons (obj, callback) {
    var params = {
      'app_key': InitData.appKey,
      'phone': obj.phone,
      'page': obj.page,
      'rows': obj.rows,
      'status': obj.status // 1未用(已绑定) 2已用 3失效
    }
    Vue.http.get(InitData.weixinUrl + '/v5/passenger/getCoupons', {params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  amendPersonalData (obj, callback) { // 修改个人资料
    var params = {
      'app_key': InitData.appKey,
      'name': obj.name,
      'gender': obj.gender,
      'phone': obj.phone,
      'memberEcn': obj.memberEcn,
      'memberEcp': obj.memberEcp,
      'address': obj.address,
      'lat': obj.lat,
      'lng': obj.lng
    }
    Vue.http.post(InitData.weixinUrl + '/v5/passenger/update', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  qrCode (obj, callback) { // 获取推广二维码
    var params = {
      'app_key': InitData.appKey,
      'company_id': obj.company_id,
      'type': 2,
      'id': obj.id
    }
    Vue.http.get('/api/v1/shareLink', {params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  recommendRecord (obj, callback) { // 推荐记录
    var params = {
      'app_key': InitData.appKey,
      'passengerId': obj.passengerId,
      'page': obj.page,
      'rows': obj.rows,
      'payType': 'RECHARGE_TYPE_REBATE'
    }
    Vue.http.get(InitData.weixinUrl + '/v5/passenger/recommendRecord', {params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  invoiceApply (obj, callback) {
    var params = {
      'app_key': InitData.appKey,
      'phone': obj.phone,
      'money': obj.money,
      'type': obj.type,
      'memo': obj.memo
    }
    Vue.http.post(InitData.weixinUrl + '/v5/passenger/applyInvoice', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  getInvoiceOrders (params, callback) { // 获取 发票申请列表
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/invoiceOrders', params)
    Vue.http.get('/v1/invoiceOrders', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  imformNum (obj, callback) {
    var params = {
      'app_key': InitData.appKey,
      'passengerId': obj.passengerId
    }
    Vue.http.get(InitData.weixinUrl + '/v5/passenger/getNotReadNotices', {params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  upImformNum (obj, callback) {
    var params = {
      'app_key': InitData.appKey,
      'passengerId': obj.passengerId,
      'noticeIds': obj.noticeIds
    }
    Vue.http.post(InitData.weixinUrl + '/v5/passenger/updateNoticeRead', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  userSumPay (obj, callback) {
    var params = {
      'timeStamp': Date.parse(new Date()) / 1000,
      'user_id': window.configure.passengerInfo.id,
      'app_key': window.configure.appKey,
      'open_id': obj.open_id,
      'pay_type': 'weixin',
      'money': obj.money,
      'type': 1
    }
    var url = 'api/v1/recharge'
    Vue.http.put(url, params, {emulateJSON: true}).then(
      data => {
        if (data.body.code === 1) {
          var content = data.body.weixinResult

          WX.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: window.configure.WXappId, // 必填，公众号的唯一标识
            timeStamp: content.wx_app_ts, // 必填，生成签名的时间戳
            nonceStr: content.wx_app_nonce, // 必填，生成签名的随机串
            signature: content.wx_app_sign, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })

          WX.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            WX.chooseWXPay({
              timestamp: content.wx_app_ts, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: content.wx_app_nonce, // 支付签名随机串，不长于 32 位
              package: content.wx_app_pkg, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
              signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: content.wx_app_sign, // 支付签名
              success: function (res) {
                // 支付成功后的回调函数
                callback('充值成功')
              }
            })
          })
          WX.error(function (res) {
            callback('充值失败')
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          })
        } else {
          callback(data.body.errorMsg)
        }
      }
    )
  },
  Articlebyalias (obj, callback) {
    Vue.http.get('/v1/articlebyalias', {params: obj}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  
  /**
   * v5获取优惠券
   * @param {*} params 
   * @param {*} callback 
   */
  getCouponsApi (params, callback) {
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/coupons', params)
    if (params.passenger_id) {
      let url = InitData.weixinUrl + '/coupons'
      Vue.http.get(url, {params}).then(
        data => {
          callback(data.coupon)
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/userCenter.js